import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bc23218"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "circular-border" }
const _hoisted_2 = { class: "image" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { id: "info" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "header-card" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "footer" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Alguma observação?", -1))
const _hoisted_13 = { class: "subtotal-footer" }
const _hoisted_14 = { class: "footer-buttons" }
const _hoisted_15 = { class: "quantity-button" }
const _hoisted_16 = { class: "quantity" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_with_balance = _resolveComponent("header-with-balance")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_select_quantity_suboption = _resolveComponent("select-quantity-suboption")!
  const _component_select_unique_suboption = _resolveComponent("select-unique-suboption")!
  const _component_select_multiple_suboption = _resolveComponent("select-multiple-suboption")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_skeleton_text = _resolveComponent("ion-skeleton-text")!
  const _component_options_card_skeleton = _resolveComponent("options-card-skeleton")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { ref: "content" }, {
        default: _withCtx(() => [
          _createVNode(_component_header_with_balance, {
            "has-go-back-modal": true,
            title: `Escolha as opções`,
            "has-go-back": false
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.productRef.image)
                ? (_openBlock(), _createBlock(_component_ion_img, {
                    key: 0,
                    src: `https://cdn.thelivery.com.br/img/products/large/${_ctx.productRef.image}`
                  }, null, 8, ["src"]))
                : _createCommentVNode("", true)
            ]),
            (!_ctx.loadingRef)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.productRef.name), 1),
                    (_ctx.productRef.description)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.productRef.description), 1))
                      : _createCommentVNode("", true)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productRef.options, (option) => {
                    return (_openBlock(), _createBlock(_component_ion_card, {
                      id: `option${option.id}`,
                      key: option.id,
                      class: "container"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_content, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_6, [
                              (option.mandatory)
                                ? (_openBlock(), _createElementBlock("h5", _hoisted_7, _toDisplayString(option.name) + "*", 1))
                                : (_openBlock(), _createElementBlock("h5", _hoisted_8, _toDisplayString(option.name), 1)),
                              (option.max_selected > 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.quantitySelected(option.id, option.max_selected)), 1))
                                : _createCommentVNode("", true)
                            ]),
                            (option.plus == 1)
                              ? (_openBlock(), _createBlock(_component_select_quantity_suboption, {
                                  key: 0,
                                  suboptions: option.suboptions,
                                  "already-selected": option.selected?.suboptions,
                                  onSelectSuboption: ($event: any) => (_ctx.changeSelection(option, $event))
                                }, null, 8, ["suboptions", "already-selected", "onSelectSuboption"]))
                              : (option.max_selected == 1)
                                ? (_openBlock(), _createBlock(_component_select_unique_suboption, {
                                    key: 1,
                                    suboptions: option.suboptions,
                                    "already-selected": option.selected?.suboptions,
                                    mandatory: option.mandatory,
                                    onSelectSuboption: ($event: any) => (_ctx.changeSelection(option, $event)),
                                    onPreselectSuboption: ($event: any) => (_ctx.select(option, $event))
                                  }, null, 8, ["suboptions", "already-selected", "mandatory", "onSelectSuboption", "onPreselectSuboption"]))
                                : (_openBlock(), _createBlock(_component_select_multiple_suboption, {
                                    key: 2,
                                    option: option.name,
                                    suboptions: option.suboptions,
                                    "max-selected": option.max_selected,
                                    "already-selected": option.selected?.suboptions,
                                    onSelectSuboption: ($event: any) => (_ctx.changeSelection(option, $event))
                                  }, null, 8, ["option", "suboptions", "max-selected", "already-selected", "onSelectSuboption"]))
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["id"]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_ion_skeleton_text, {
                    class: "product-name-skeleton",
                    animated: ""
                  }),
                  _createVNode(_component_ion_skeleton_text, {
                    class: "product-description-skeleton",
                    animated: ""
                  }),
                  _createVNode(_component_ion_skeleton_text, {
                    class: "product-description-skeleton",
                    animated: ""
                  }),
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
                    return _createVNode(_component_options_card_skeleton, { key: i })
                  }), 64))
                ]))
          ])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_ion_footer, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_ion_input, {
                  modelValue: _ctx.productNote,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.productNote) = $event)),
                  type: "text",
                  placeholder: "Ex: sem cebola, pouco molho, etc.",
                  class: "observation",
                  autocomplete: "off"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("span", _hoisted_15, [
                      _createVNode(_component_ion_button, {
                        size: "small",
                        color: "primary",
                        class: "circle circle-left",
                        onClick: _ctx.removeProduct
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.remove }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.quantity), 1),
                      _createVNode(_component_ion_button, {
                        size: "small",
                        color: "primary",
                        class: "circle circle-right",
                        onClick: _ctx.addProduct
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.add }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]),
                  _createVNode(_component_ion_button, {
                    shape: "round",
                    color: "primary",
                    class: "next-button",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addToCart()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.editIndex || _ctx.editIndex == 0 ? "Editar" : "Adicionar") + " " + _toDisplayString(_ctx.moneyMask(_ctx.totalPrice)), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}